import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';

export interface Option {
  value: number | string;
  label?: string;
}

interface SelectFieldProps {
  value: number | string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Option[];
  placeholder?: string;
  label?: string;
  name?: string;
  required?: boolean
}

const SelectField: React.FC<SelectFieldProps> = ({ value, onChange, options, placeholder, label, name, required=false }) => {
  return (
    <InputGroup className="mb-3">
      {label && <InputGroup.Text>{label}</InputGroup.Text>}
      <Form.Select value={value} onChange={onChange} name={name} required={required}>
        <option value="" disabled>{placeholder}</option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label || option.value}
          </option>
        ))}
      </Form.Select>
    </InputGroup>
  );
};

export default SelectField;